import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};

const defaultProps = {
  className: '',
  id: '',
};

const Body = ({ children, className, id }) => {
  return (
    <tbody id={id} className={`Table__body ${className}`}>
      {children}
    </tbody>
  );
};

Body.propTypes = propTypes;
Body.defaultProps = defaultProps;

export default Body;



// WEBPACK FOOTER //
// ../ui-components/components/Table/Body.jsx